'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = batchMiddleware;

var _utils = require('../utils');

// Max out at roughly 100kb (express-graphql imposed max)
var DEFAULT_BATCH_SIZE = 102400; /* eslint-disable no-param-reassign */

function batchMiddleware() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var batchTimeout = opts.batchTimeout || 0; // 0 is the same as nextTick in nodeJS
  var allowMutations = opts.allowMutations || false;
  var batchUrl = opts.batchUrl || '/graphql/batch';
  var maxBatchSize = opts.maxBatchSize || DEFAULT_BATCH_SIZE;
  var singleton = {};

  return function (next) {
    return function (req) {
      // never batch mutations with files
      // mutation without files can be batched if allowMutations = true
      if (req.relayReqType === 'mutation' && (!allowMutations || global.FormData && req.body instanceof FormData)) {
        return next(req);
      }

      return passThroughBatch(req, next, {
        batchTimeout: batchTimeout,
        batchUrl: batchUrl,
        singleton: singleton,
        maxBatchSize: maxBatchSize
      });
    };
  };
}

function passThroughBatch(req, next, opts) {
  var singleton = opts.singleton;


  if (!singleton.batcher || !singleton.batcher.acceptRequests) {
    singleton.batcher = prepareNewBatcher(next, opts);
  }

  if (singleton.batcher.bodySize + req.body.length + 1 > opts.maxBatchSize) {
    singleton.batcher = prepareNewBatcher(next, opts);
  }

  // +1 accounts for tailing comma after joining
  singleton.batcher.bodySize += req.body.length + 1;

  // queue request
  return new Promise(function (resolve, reject) {
    singleton.batcher.requestMap[req.relayReqId] = {
      req: req,
      completeOk: function completeOk(res) {
        req.done = true;
        resolve(res);
      },
      completeErr: function completeErr(err) {
        req.done = true;
        reject(err);
      }
    };
  });
}

function prepareNewBatcher(next, opts) {
  var batcher = {
    bodySize: 2, // account for '[]'
    requestMap: {},
    acceptRequests: true
  };

  setTimeout(function () {
    batcher.acceptRequests = false;
    sendRequests(batcher.requestMap, next, opts).then(function () {
      return finalizeUncompleted(batcher);
    }).catch(function () {
      return finalizeUncompleted(batcher);
    });
  }, opts.batchTimeout);

  return batcher;
}

function sendRequests(requestMap, next, opts) {
  var ids = Object.keys(requestMap);

  if (ids.length === 1) {
    // SEND AS SINGLE QUERY
    var request = requestMap[ids[0]];

    return next(request.req).then(function (res) {
      request.completeOk(res);
    });
  } else if (ids.length > 1) {
    // SEND AS BATCHED QUERY
    var url = (0, _utils.isFunction)(opts.batchUrl) ? opts.batchUrl(requestMap) : opts.batchUrl;

    var req = {
      url: url,
      relayReqId: 'BATCH_QUERY:' + ids.join(':'),
      relayReqObj: requestMap,
      relayReqType: 'batch-query',
      method: 'POST',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json'
      },
      body: '[' + ids.map(function (id) {
        return requestMap[id].req.body;
      }).join(',') + ']'
    };

    return next(req).then(function (batchResponse) {
      if (!batchResponse || !Array.isArray(batchResponse.json)) {
        throw new Error('Wrong response from server');
      }

      batchResponse.json.forEach(function (res) {
        if (!res) return;
        var request = requestMap[res.id];
        if (request) {
          var responsePayload = copyBatchResponse(batchResponse, res);
          request.completeOk(responsePayload);
        }
      });
    }).catch(function (e) {
      ids.forEach(function (id) {
        requestMap[id].completeErr(e);
      });
    });
  }

  return Promise.resolve();
}

// check that server returns responses for all requests
function finalizeUncompleted(batcher) {
  Object.keys(batcher.requestMap).forEach(function (id) {
    if (!batcher.requestMap[id].req.done) {
      batcher.requestMap[id].completeErr(new Error('Server does not return response for request with id ' + id + ' \n' + ('eg. { "id": "' + id + '", "data": {} }')));
    }
  });
}

function copyBatchResponse(batchResponse, res) {
  // Fallback for graphql-graphene and apollo-server batch responses
  var json = res.payload || res;
  return {
    ok: batchResponse.ok,
    status: batchResponse.status,
    statusText: batchResponse.statusText,
    url: batchResponse.url,
    headers: batchResponse.headers,
    json: json
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-relay-network-layer/lib/middleware/batch.js
// module id = 1510
// module chunks = 0